export default __webpack_public_path__ + "static/media/General's Vambraces of the Warring States.ef2f7205.jpg";